import { render, staticRenderFns } from "./CharacteristicStep4.vue?vue&type=template&id=40d71054&"
import script from "./CharacteristicStep4.vue?vue&type=script&lang=js&"
export * from "./CharacteristicStep4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports